import { MenuElement } from 'frontend-container/components/Menu/types';

import { SalesActivitiesSettingCode } from '@ac/library-api';
import { acConfig } from '@ac/library-utils/dist/declarations';
import { IconName } from '@ac/web-components';

export const salesActivitiesMenu: MenuElement = {
  translation: 'MENU.SALES_ACTIVITIES.TITLE',
  icon: IconName.default,
  id: 'menu-sales-activities',
  settings: [SalesActivitiesSettingCode.SalesActivitiesFunctionality],
  items: [
    {
      link: `${acConfig.newFrontendUrls.taskManagement}/sales-activities/dashboard`,
      aliases: [`${acConfig.newFrontendUrls.taskManagement}/sales-activities`],
      code: 'SalesActivitiesDashboard',
      translation: 'MENU.SALES_ACTIVITIES.ITEMS.DASHBOARD',
    },
  ],
};
